// console.debug(`${new Date().toISOString()} ${performance.now().toFixed(2)}ms [${import.meta.url}]`)
import { defineStore } from 'pinia'
import { computed, ref } from 'vue'
import { useSessionUI } from '../../utils/composables/useSessionUI'
import type { UTCDate } from '../../utils/fechador'
import * as fechador from '../../utils/fechador'
import { isUTCDate, toYMD } from '../../utils/fechador'
import { log } from '../../utils/logger'
import { fetchEuribor } from './euriborData'
import { type FetchOptions, type TimeSeries } from './irsData'

const { isF3 } = useSessionUI()

// ****************************************************************************
// EuriborStore Composition API ***********************************************
// ****************************************************************************
export const useEuriborStore = defineStore('euriborStore', () => {
    const euriborInitialized = ref<boolean | undefined>()

    const euriborSeries = ref<TimeSeries>({ fechas: [], valores: [] })
    const lastEuribor = computed<{ fecha: UTCDate; valor: number }>(() => {
        // log.info('lastEuribor:', {
        //     fecha: euriborSeries.value.fechas[0],
        //     valor: euriborSeries.value.valores[0]
        // })
        return { fecha: euriborSeries.value.fechas[0], valor: euriborSeries.value.valores[0] }
    })

    // handling error if fetch fails --> isInitialized === false
    // Called by the router if the route has: (meta: { requiresMarket: true })
    async function initEuriborStore(options: FetchOptions) {
        if (euriborInitialized.value !== undefined) return

        euriborInitialized.value = false
        if (isF3.value) return // --> noMarket

        euriborSeries.value = await fetchEuribor(options)
        if (euriborSeries.value.fechas.length === 0) {
            log.warn('Falla descargar Euribor de Banco de España.')
            return
        }

        euriborInitialized.value = true

        // log.debug('#euribor:', euriborSeries.value.fechas.length)
    }

    function getEuribor(date: Date) {
        if (!euriborInitialized.value) return 0
        if (!isUTCDate(date)) {
            log.error('getEuribor, date not UTC midnight:', date.toISOString())
            return 0
        }

        // // log.info('getEuribor for date:', date.toISOString())
        // const ym = toDateString(date).slice(0, 7)
        // // log.info('ym:', ym)
        // const index = euriborSeries.value.fechas.findIndex((f: any) => f.startsWith(ym))
        // return index !== -1 ? euriborSeries.value.valores[index] : 0

        const idx = euriborSeries.value.fechas.findIndex((f) => fechador.eqDay(f, date))

        // log.debug('idx:', idx)
        return idx !== -1 ? euriborSeries.value.valores[idx] : 0
    }

    return {
        initEuriborStore, // async
        euriborInitialized,

        euriborSeries,
        lastEuribor,
        getEuribor
    }
})
